 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_SERIES_PAGE from '@/components/xhtml/01_Series_Page'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_INTRODUCTION from '@/components/xhtml/06_INTRODUCTION'
 import XHTML07_1__TALK_OF_THE_TOWN__BEGINNINGS from '@/components/xhtml/07_1__TALK_OF_THE_TOWN__Beginnings'
 import XHTML08_2__UP_THE_NECK__PRETENDERS from '@/components/xhtml/08_2__UP_THE_NECK__Pretenders'
 import XHTML09_3__BIRDS_OF_PARADISE__EXTENDED_P from '@/components/xhtml/09_3__BIRDS_OF_PARADISE__Extended_P'
 import XHTML10_4__TIME_THE_AVENGER__LEARNING_TO from '@/components/xhtml/10_4__TIME_THE_AVENGER__Learning_to'
 import XHTML11_5__DON_T_GET_ME_WRONG__GET_CLOSE from '@/components/xhtml/11_5__DON_T_GET_ME_WRONG__Get_Close'
 import XHTML12_6__LEGALISE_ME__LAST_OF_THE_INDE from '@/components/xhtml/12_6__LEGALISE_ME__Last_of_the_Inde'
 import XHTML13_7__COMPLEX_PERSON__LOOSE_SCREW_A from '@/components/xhtml/13_7__COMPLEX_PERSON__Loose_Screw_a'
 import XHTML14_8__YOU_OR_NO_ONE__FIDELITY___STO from '@/components/xhtml/14_8__YOU_OR_NO_ONE__Fidelity___Sto'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML15_ACKNOWLEDGMENTS from '@/components/xhtml/15_ACKNOWLEDGMENTS'
 import XHTML16_SOURCES_AND_NOTES from '@/components/xhtml/16_SOURCES_AND_NOTES'
 import XHTML17_SELECTED_DISCOGRAPHY from '@/components/xhtml/17_SELECTED_DISCOGRAPHY'
 import XHTML18_INDEX from '@/components/xhtml/18_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_INTRODUCTION",
 			"name" : "xhtml/06_INTRODUCTION",
 			"component" : XHTML06_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/07_1__TALK_OF_THE_TOWN__Beginnings",
 			"name" : "xhtml/07_1__TALK_OF_THE_TOWN__Beginnings",
 			"component" : XHTML07_1__TALK_OF_THE_TOWN__BEGINNINGS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js